import axios from 'axios'

const interceptorJWT = axios.interceptors.request.use(
    async request => {
        request.headers['authorization'] = localStorage.getItem('user')
        request.headers['refresh-authorization'] = localStorage.getItem('refreshToken')
        return request
    },
    error => {
        return Promise.reject(error)
    }
)
axios.interceptors.response.use(
    response => {
        return response
    },
    async error => {

        const status = error.response ? error.response.status : null

        if (status === 401) {
            
        }
        return Promise.reject(error)
    }
)
export default interceptorJWT